import React from "react";
import _ from "lodash";
import { getContrastText, getDeptShortName } from "../../utils/misc";
import styles from "./PlanPill.module.scss";
import { Chip, useTheme } from "@material-ui/core";

const PlanPill = ({ plan, number, noPlanVal, noIndent, noMargin }) => {
  const theme = useTheme();
  if (_.isNil(plan)) {
    return (
      <Chip
        size="small"
        className={styles.pillWrapperNone}
        style={{
          margin: noMargin ? 0 : theme.spacing(1),
          marginLeft: noMargin || noIndent ? 0 : theme.spacing(1),
        }}
        label={<span className={styles.pillText}>{noPlanVal ? noPlanVal : "NONE"}</span>}
      />
    );
  }

  const { departmentName, color, shortName } = plan;
  const fallbackShortName = getDeptShortName(departmentName, shortName);
  const bgColor = color || "#000000";

  return (
    <Chip
      className={styles.pillWrapper}
      size="small"
      style={{
        backgroundColor: bgColor,
        color: theme.palette.getContrastText(bgColor),
        margin: noMargin ? 0 : theme.spacing(1),
        marginLeft: noMargin || noIndent ? 0 : theme.spacing(1),
      }}
      label={
        <span className={styles.pillText}>
          {fallbackShortName}
          {!_.isNil(number) && ` - ${number}`}
        </span>
      }
    />
  );
};

export default PlanPill;
